import { Trash2 } from 'lucide-react';
import type { TFunction } from 'i18next';

export function RemoveVendorButton({
  organizationId,
  organizationName,
  onClick,
  t,
}: Readonly<{
  organizationId: string;
  organizationName: string;
  onClick: () => void;
  t: TFunction;
}>) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={t('order_builder.remove_seller.action_title', {
        name: organizationName,
      })}
      aria-label={t('order_builder.remove_seller.action_aria_label', {
        name: organizationName,
      })}
      data-testid={`remove-vendor-${organizationId}`}
      className="p-1 hover:bg-neut-100 rounded transition-colors"
    >
      <Trash2 className="w-4 h-4 text-neut-400 hover:text-error-600" />
    </button>
  );
}
